<template>
  <picker-field
    :label="label"
    :value="value"
    ref="picker"
    @open="onSearch"
  >
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>{{ item.mr_name }}</p>
          </div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField,
  },
  props: {
    label: {
      type: String,
      default: "会议室",
    },
    value: String,
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
          url: "/api/oa/meetingroom/list",
        }).then(function (res) {
          if (res.success) {
            me.items = res.data;
          } else {
            me.$weui.topTips(res.message, 2000);
          }
        });
    },
  },
};
</script>